"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFolderModalVisibleState = void 0;
const react_1 = __importDefault(require("react"));
const folder_1 = require("../../../server/models/folder");
const react_i18next_1 = require("react-i18next");
const recoil_1 = require("recoil");
const FoldersRoute_1 = __importDefault(require("../../../routes/FoldersRoute"));
const react_router_dom_1 = require("react-router-dom");
const RedirectTo_1 = __importDefault(require("../../../utilities/RedirectTo"));
const SaveInFolderModal_1 = __importDefault(require("../Modals/SaveInFolderModal"));
exports.updateFolderModalVisibleState = (0, recoil_1.atom)({
    key: 'updateFolderModalVisibleState',
    default: false,
});
const UpdateFolderModal = ({ defaultFolderId, currentFolderName, parentId, t, }) => {
    const [visible, setVisible] = (0, recoil_1.useRecoilState)(exports.updateFolderModalVisibleState);
    const history = (0, react_router_dom_1.useHistory)();
    const successCallback = (res) => {
        if (location.pathname
            .toLowerCase()
            .includes(FoldersRoute_1.default.path.toLowerCase()) &&
            res) {
            (0, RedirectTo_1.default)({ history, path: `${FoldersRoute_1.default.path}/${res.id}` });
        }
    };
    const saveInFolderModalProps = {
        id: 'updateFolderModal',
        defaultFolderId: parentId,
        currentFolderName: currentFolderName,
        formSubmitCallback: async (title) => await (0, folder_1.updateFolder)(defaultFolderId, {
            Name: title,
            ParentId: parentId.toString(),
        }),
        successCallback: successCallback,
        successMessage: t('folderUpdateSuccess'),
        failureMessage: t('folderUpdateFail'),
        hideFolderTree: true,
        errorMessage: t('folderUpdateError'),
        titleName: 'updateFolder',
        titleValidationCallback: async (title) => await (0, folder_1.verifyFolderNameUniqueIn)(title, parentId.toString()),
        notificationMessage: t('folderUpdateNotify'),
        placeholder: t('folderUpdatePlaceholder'),
        duplicateErrorMessage: t('folderUpdateDuplicate'),
        headerText: `${t('folderUpdateHeader')} "${currentFolderName}”`,
        primaryButtonText: t('folderUpdateButton'),
        autoFocus: true,
        visible: visible,
        setVisible: (isVisible) => setVisible(isVisible),
        t: t,
    };
    return react_1.default.createElement(SaveInFolderModal_1.default, { ...saveInFolderModalProps });
};
exports.default = (0, react_i18next_1.withTranslation)('ModalWindow')(UpdateFolderModal);
